import { List, ListItem, ListItemButton, ListItemText } from '@mui/material';
import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { SCREEN_ROUTES } from '../common/screens';
import { SideBarItem } from '../common/sidebarItems';
import { getCurrentScreen } from '../screens/app/App';
// import { useCkycUpdateNotificationState } from '../common/state';

export const SideBarGroup: React.FC<{
    header: string;
    items: SideBarItem[];
}> = ({ header, items }) => (
    <>
        <p
            style={{
                fontWeight: 500,
                color: '#51CBFF',
                fontSize: '0.8rem',
                marginLeft: '2.2em',
            }}>
            {header}
        </p>
        <List>
            {items.map((item) => (
                <SideBarMenu {...item} key={item.screen} />
            ))}
        </List>
    </>
);

const SideBarMenu: React.FC<SideBarItem> = ({ Icon, screen }) => {
    const navigate = useNavigate();
    const location = useLocation();
    const curScreen = getCurrentScreen(location);
    const screenHandler = (): void => {
        navigate(SCREEN_ROUTES[screen]);
    };
    return (
        <ListItem key={screen} disablePadding>
            <ListItemButton
                className={'SideBarItem'}
                selected={screen === curScreen}
                style={{ marginLeft: '0.6em' }}
                onClick={screenHandler}>
                <Icon style={{ color: 'white', marginRight: '0.6em' }} />
                <ListItemText primary={screen} style={{ color: 'white' }} />
            </ListItemButton>
        </ListItem>
    );
};
